import appSettingsLogger from "./appSettingsLogger";
import fetchAppSettings from "./core/fetchAppSettings";
class AppSettingsManager {
    settings = null;
    isInitializedState = false;
    error = null;
    subscribers = new Set();
    async init({ appId }) {
        await this.loadSettings(appId);
        this.isInitializedState = true;
        this.notifySubscribers();
    }
    async loadSettings(appId) {
        try {
            this.settings = await fetchAppSettings({ appId });
            this.error = null;
        }
        catch (error) {
            this.error = error;
            appSettingsLogger.error("Failed to load application settings:", error);
        }
    }
    async reloadAppSettings({ appId }) {
        await this.loadSettings(appId);
        this.notifySubscribers();
    }
    getSettings = () => {
        return this.settings;
    };
    getIsInitialized = () => {
        return this.isInitializedState;
    };
    getError = () => {
        return this.error;
    };
    subscribe = (listener) => {
        this.subscribers.add(listener);
        return () => this.subscribers.delete(listener);
    };
    notifySubscribers() {
        this.subscribers.forEach((listener) => listener());
    }
}
export const appSettings = new AppSettingsManager();
export default appSettings;
